import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Input, RequiredInput } from './input'


export type Phone = {
  phone?: string;
  email?: string;
}

export interface PhoneFormProps {
  value: Phone;
  onChange: (value: Phone) => void;
  showError?: boolean;
  disabled?: boolean;
}

export const PhoneForm: React.FC<PhoneFormProps> = function (props) {
  const { value: phone, onChange, showError = false, disabled = false } = props

  function update (key: string, value: string) {
    onChange({
      ...phone,
      [key]: value
    })
  }

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item xs>
        { /* eslint-disable-next-line no-useless-escape */ }
        <RequiredInput disabled={disabled} error={showError && (!phone.phone || !phone.phone?.match(/^[-+\/\s]*([0-9][-+\/\s]*){9,}$/))} value={phone.phone || ''} onChange={value => update('phone', value)} label="Numer telefonu" />
      </Grid>
      <Grid item xs>
        <Input disabled={disabled} value={phone.email || ''} onChange={value => update('email', value)} label="Adres email (pole nieobowiązkowe, nie podanie adresu e-mail uniemożliwi kontakt za pośrednictwem poczty elektronicznej)" />
      </Grid>
    </Grid>
  )
}
